import { Container, Title, Text, Paper, Button } from "@mantine/core";
import { Link } from "wouter";

export default function PaymentCompleted() {
  return (
    <Container mt="xl" size="sm" ta="center">
      <Paper p="xl" mt="xl">
        <Title ta="center">Payment Completed</Title>
        <Text mt="md">
          Thank you, your payment has succeeded! Please note that it might take
          a minute for the credits to appear.
        </Text>
        <Button mt="lg" component={Link} to="/">
          Continue
        </Button>
      </Paper>
    </Container>
  );
}
